// modules/LotImage.js
import React        from 'react';

class LotImage extends React.Component {
	render() {
		return (
			<div className="lot-image-container">
				<img className="" src={this.props.children} alt={this.props.lot_name} />
				<div></div>
			</div>
		);
	}
}

export default LotImage;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LotImage.js
 **/